import { cva } from 'class-variance-authority';

const tooltipBaseStyles = [
  'absolute',
  'block',
  'py-1.5',
  'px-2.5',
  'text-sm',
  'z-50',
  'box-border',
];

const tooltipStylesSAG = cva([
  ...tooltipBaseStyles,
  'rounded-md',
  'bg-[#000028]',
  'text-white',

  'dark:bg-[#F3F3F0]',
  'dark:text-[#000028]',
]);

const tooltipStylesSHS = cva([
  ...tooltipBaseStyles,
  'shadow-md',
  'bg-white',
  'text-black',

  'dark:bg-[#1a1a1a]',
  'dark:text-white',
]);

export { tooltipStylesSAG, tooltipStylesSHS };
